export default __webpack_public_path__ + "static/media/logo-region-s.cea6ae96.png";